<template>
	<div class="customize_container">
		<div class="customize_main">
			
			<!-- 引言 -->
			<div class="panel_z">
				<div class="title">量身定制您的<br>教师培训解决方案</div>
				<div class="text">
					为加快落实《教育部等六部门关于加强新时代高校教师队伍建设改革的指导意见》（教师〔2020〕10号），机工教师特训营依托多年来服务高校教师的平台、教学资源和专家团队优势，面向各高校推出教师培训定制培训服务解决方案，致力于提供精准化培训服务及优质的培训体验，满足高校高素质、专业化、创新型教师队伍建设的个性化需求。
				</div>
				<div class="btn" @click="showClick">免费领取培训解决方案</div>
			</div>

			<!-- 培训服务模式 -->
			<div class="panel">
				<div class="panel_title">培训服务形式</div>
				<div class="panel_items panel_items_2">
					<div class="panel_item_2">
						<div class="imgbox">
							<img :src="imageDomain+'customize-pic1.png'" />
						</div>
						<div class="info">
							<div class="title">线上培训</div>
							<div class="text">互动直播或精品录课或两者的组合。</div>
						</div>
					</div>

					<div class="panel_item_2">
						<div class="imgbox">
							<img :src="imageDomain+'customize-pic4.png'" />
						</div>
						<div class="info">
							<div class="title">线上线下混合式培训</div>
							<div class="text">采用线上学习与线下面授培训相结合的培训模式。</div>
						</div>
					</div>

					<div class="panel_item_2_2">
						上述两种培训形式均包括学员的社群学习、线上讨论、专家线上答疑、作品点评指导等培训方式，视具体项目而定。
					</div>
				</div>
			</div>

			<!-- 可定制项目主题 -->
			<div class="panel">
				<div class="panel_title">可定制项目主题</div>
				<div class="panel_items">
					<div class="panel_item_3" v-for="(item,index) in subjectList">
						<div class="title">{{item.title}}</div>
						<div class="text">{{item.text}}</div>
					</div>
				</div>
			</div>

			<!-- 培训服务流程 -->
			<div class="panel">
				<div class="panel_title">培训服务流程</div>
				<div class="panel_items">
					<div class="panel_item_4">
						<img :src="imageDomain+'customize-pic3.png'" style="width: 100%;" />
						<div class="text">
							每个培训项目我们将安排专门专人与您沟通调研，明确培训需求，提供个性化、针对性的培训解决方案。
						</div>
					</div>
				</div>
			</div>

			<!-- 培训效果保障 -->
			<div class="panel">
				<div class="panel_title">培训效果保障</div>
				<div class="panel_items">
					<div class="panel_item_5" v-for="(item,index) in effectList">
						<div class="imgbox">
							<img :src="imageDomain+item.img_url" />
						</div>

						<div class="info">
							<div class="title">{{item.title}}</div>
							<div class="text">{{item.text}}</div>
						</div>
					</div>
				</div>
			</div>
			
			<!-- 介绍 -->
			<div class="panel_z last">
				<div class="title title2">期待更多机会向您介绍我们的详细培训方案~</div>
				<div class="text">我们将倾听、了解贵校在教师队伍建设方面遇到的问题和困难，并致力于通过培训的方式与您一起，共同助力高素质专业化、创新型教师队伍建设。</div>
				<div class="btn" @click="showClick">请安排培训顾问联系我</div>
			</div>

		</div>
		
		
		<!-- 提交定制培训信息 -->
		<el-dialog title="提交定制培训信息" width="640px" top="15vh" :visible.sync="show" :show-close="true">
			<div style="width: 100%; height: auto; margin: 0 auto;  padding: 0 30px;">
				<el-form :model="dynamicValidateForm" ref="dynamicValidateForm"  label-width="80px" >
					<div v-for="(domain, index) in dynamicValidateForm.domains" :key="domain.key">
						<el-form-item :prop="'domains.' + index + '.school'" label="院校" :rules="[{ required: true, message: '请输入院校名称', trigger: ['blur', 'change'] }]">
							<el-input v-model="domain.school" placeholder="请输入院校名称" clearable></el-input>
						</el-form-item>
						<el-form-item :prop="'domains.' + index + '.name'" label="姓名" :rules="[{ required: true, message: '请输入姓名', trigger: ['blur', 'change'] }]">
							<el-input v-model="domain.name" placeholder="请输入姓名"></el-input>
						</el-form-item>				
						<el-form-item :prop="'domains.' + index + '.mobile'" label="手机" :rules="[{ required: true, message: '请输入手机号码', trigger: ['blur', 'change'] },{ pattern: /^[1][3-9][0-9]{9}$/, message: '请输入正确的手机号码', trigger: ['blur', 'change'] }]">
							<el-input v-model="domain.mobile" placeholder="请输入手机号码"></el-input>
						</el-form-item>
						<el-form-item :prop="'domains.' + index + '.email'" label="邮箱" :rules="[{ required: true, message: '请输入邮箱地址', trigger: ['blur', 'change'] },{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }]">
							<el-input v-model="domain.email" placeholder="请输入电子邮箱地址"></el-input>
						</el-form-item>
						<el-form-item :prop="'domains.' + index + '.content'" label="需求" :rules="[ { required: true, message: '请输入需求', trigger: ['blur', 'change'] }]">
							<el-input type="textarea" v-model="domain.content" placeholder="请简单描述您的培训诉求，如培训对象，需要提升哪些能力？或者希望的培训主题等。"></el-input>
						</el-form-item>
					</div>
				</el-form>
			
			</div>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeClick">取消</el-button>
				<el-button type="danger" @click="submit">提交定制培训信息</el-button>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
	import apiUrl from "../../js/apiUrl.js";

	export default {
		data() {
			return {
				imageDomain: this.imageDomain + 'cmptt/customize/',
				subjectList: [{
						title: '师德师风建设',
						text: '强化高校教师思想政治素质和师德师风建设，落实立德树人任务'
					},
					{
						title: '高校教师职业发展与规划',
						text: '高校教师的专业发展阶段理论，如何做好生涯规划、案例等'
					},
					{
						title: '高校教师教学能力提升',
						text: '教学设计、教案撰写、各类教学大赛备赛'
					},
					{
						title: '信息化教学能力提升',
						text: '信息化教育设计、信息化工具应用、职业教育教学能力大赛备赛指导等'
					},
					{
						title: '一流课程建设能力提升',
						text: '五大类一流课程建设的方法与案例，如线上一流课程、线上线下混合式一流课程等'
					},
					{
						title: '在线教学能力提升',
						text: '在线教学/混合式教学设计、教学评价、翻转课堂、在线教学环境与工具等'
					},
					{
						title: '课程思政教学设计能力',
						text: '涵盖新工科/理科/商科/计算机机电/艺术/管理等专业课程如何开展课程思政建设'
					},
					{
						title: '职业院校教学能力大赛',
						text: '教学能力大赛精讲与参赛技巧、信息化教学设计、信息技术工具应用'
					},
					{
						title: '高校教师科研能力提升',
						text: '涵盖教育科研、专业研究方法、课题/基金项目申请、学术论文撰写等'
					},
					{
						title: '职业教育教学成果奖培育与申报',
						text: '教学成果奖培育与凝练方法技能及各级别获奖案例分享'
					},
					{
						title: '高校新媒体营销实战',
						text: '直播营销、直播带货、短视频内容策划与营销、社群营销、视频号营销、高校宣传及招生新媒体营销'
					},
					{
						title: '新媒体教学能力提升',
						text: '短视频内容策划与运营、直播运营、新媒体数据分析技能、教学设计案例、自媒体运营等'
					},
					{
						title: '大数据技术教学能力提升',
						text: '大数据技术（Python、Hadoop+spark方向）的基础知识学习+案例实训'
					},
					{
						title: '人工智能教学能力提升',
						text: '人工智能技术，包括机器学习、深度学习、自然语言处理、计算机视觉以及相应的工具与实践平台等前沿技术和案例实训'
					},
					{
						title: 'web前端教学能力提升',
						text: '前端行业发展及前端开发实战技能，移动web、小程序、桌面应用开发及案例分享'
					},
					{
						title: '专业建设与课程建设',
						text: '专业建设、课程建设、专业群、教学创新团队、实践教学、实训中心建设与管理等'
					},
					{
						title: '活页式教材设计与开发',
						text: '活页式教材策划、编写方法及案例分享'
					},
					{
						title: '数字媒体教学能力提升',
						text: '数字媒体专业分析、教学体系、教学新理念、课程建设案例、教材建设研究与案例分享'
					},
				],
				effectList: [{
						img_url: 'customize-pic4.png',
						title: '科学培训设计',
						text: '安排专门课程设计师负责项目培训需求分析，进行科学的培训目标设定和内容策划，设计培训项目实施流程，保障培训效果和学习体验。'
					},
					{
						img_url: 'customize-pic2.png',
						title: '强大专家资源',
						text: '依托名师、名校、出版社知名作者等优质专家资源，持续研发并输出优质培训内容并通过合理的机制实现课程内容的持续优化和迭代升级。'
					},
					{
						img_url: 'customize-pic5.png',
						title: '智能学习平台',
						text: '基于自主研发的线上学习平台，提供集直播、录播、在线测试、在线答疑、作业批改与点评等实用功能，支持PC端、移动端自主选择，强大的学习数据分析功能。'
					},
					{
						img_url: 'customize-pic6.png',
						title: '精细项目运营',
						text: '运营团队负责课前、课中、课后的精细化课程运营工作，涵盖社群答疑、学习手册推送、开班仪式组织、全程督学、学习过程监控、数据反馈、效果跟踪等，切实保障培训目标的达成。'
					},
				],
				dynamicValidateForm: {
					domains: [{
						school: '',
						name: '',
						mobile: '',
						email: '',
						content: '',
					}]
				},
				show: false
			}
		},
		created() {
			document.title = "定制培训";
		},
		methods: {
			closeClick(){
				this.show = false;
			},
			showClick(){
				this.show = true;
			},
			submit() {
				var that = this;
				this.$refs['dynamicValidateForm'].validate((valid) => {
					if (valid) {
						that.confirmAjax();
					}
				});
			},
			confirmAjax() {
				var that = this;
				var url = apiUrl.tt_service_confirm;
				var parm = { user_list_json : JSON.stringify(that.dynamicValidateForm.domains)};
				this.Ajax(url, parm, (data) => {
					that.$message({
					  showClose: true,
					  message: '提交成功',
					  type: 'warning'
					});
					that.show = false;
				});
			},
		},
	}
</script>

<style lang="scss" scoped>
	.customize_container {
		background-color: #fff;
		width: 100vw;
		min-height: 100vh;
		padding-bottom: 40px !important;
		box-sizing: border-box;
		
		/deep/.el-button--danger{
			background-color: #c93a2e !important;
			border-color: #c93a2e !important;
		}

		.customize_main {
			width: 1200px;
			margin: 15px auto;
			display: flex;
			flex-direction: column;
			padding: 10px 0;

			.panel_z {
				width: 100%;
				border: 1px solid #eee;
				padding: 20px;
				line-height: 1.75;
				box-sizing: border-box;
				
				&.last{
					display: flex;
					flex-direction: column;
					align-items: center;
					margin-top: 40px;
					
				}

				.title {
					font-size: 40px;
					font-weight: 600;
					color: #c93a2e;
					margin-bottom: 40px;
					
					&.title2{
						font-size: 36px !important;
						margin-bottom: 20px !important;
					}
				}

				.text {
					font-size: 15px;
					text-align: justify;
				}

				.btn {
					width: 320px;
					height: 44px;
					border-radius: 4px;
					background-color: #c93a2e;
					color: #fff;
					margin-top: 20px;
					display: flex;
					justify-content: center;
					align-items: center;
					cursor: pointer;
				}
			}

			.panel {
				margin-top: 40px;
				line-height: 1.75;
				text-align: justify;

				.panel_title {
					font-size: 36px;
					font-weight: 600;
					color: #c93a2e;
					text-align: center;
				}

				.panel_items {
					margin-top: 20px;
					font-size: 15px;
					display: flex;
					flex-wrap: wrap;

					&.panel_items_2 {
						width: 100%;
						border: 1px solid #eee;
						padding: 20px;
						box-sizing: border-box;

						.panel_item_2_2 {
							width: 100%;
							margin-top: 15px;
						}

						.panel_item_2 {
							width: 50%;
							display: flex;
							align-items: center;
							padding: 10px 0;
							box-sizing: border-box;

							.imgbox {
								width: 190px;
								height: 190px;
								margin-right: 20px;
							}

							.info {
								flex: 1;

								.title {
									font-size: 24px;
									font-weight: 600;
									margin-bottom: 10px;
								}

								.text {
									font-size: 15px;
								}
							}
						}
					}



					.panel_item_5 {
						width: calc((100% - 20px)/2);
						border: 1px solid #eee;
						padding: 20px;
						box-sizing: border-box;
						display: flex;
						flex-direction: column;
						align-items: center;
						margin-bottom: 20px;

						&:nth-of-type(2n+2) {
							margin-left: 20px !important;
						}

						.imgbox {
							width: 173px;
							height: 173px;
							display: flex;
							justify-content: center;
							align-items: center;
						}

						.info {
							margin-top: 15px;

							.title {
								font-size: 20px;
								font-weight: 600;
								text-align: center;
								margin-bottom: 10px;
							}

							.text {
								font-size: 15px;
								text-align: justify;
							}
						}
					}

					.panel_item_4 {
						width: 100%;
						padding: 30px 40px;
						border: 1px solid #eee;
						box-sizing: border-box;
						display: flex;
						align-items: center;

						.text {
							margin-left: 20px;
						}
					}

					.panel_item_3 {
						border: 1px solid #eee;
						padding: 20px;
						box-sizing: border-box;
						width: calc((100% - 40px)/3);
						margin-bottom: 20px;

						&:nth-of-type(3n+2) {
							margin-left: 20px !important;
							margin-right: 20px !important;
						}

						.title {
							font-size: 20px;
							font-weight: 600;
							text-align: center;
							margin-bottom: 10px;
						}

						.text {
							font-size: 15px;
							text-align: justify;
						}
					}
				}
			}
		}
	}
</style>